<div class="custom-select-search" :class="customSelectActive">
    <label class="col-form-label" v-if="label" :for="id" ref="labelForm">{{ label }} <span v-if="required">(*)</span></label>
    <input class="form-control" :class="{ 'is-error': isError }" v-model="valueSelectSearch" type="text" :id="id" :disabled="disabled" :placeholder="placeholder"/>
    <span class="arrow"></span>
    <ul class="select-dropdown" role="listbox" id="select-dropdown" ref="modalRef">
        <li role="option" ref="select-dropdown" v-for="option in options_val" :key="option.key" @click="chooseOption(option.value, option.name)">
            <span :data-val="option.value">{{option.name}}</span>
        </li>
    </ul>
    <div class="error-text" v-if="errorText" :style="{left: distanceWithLabel}">{{errorText}}</div>
</div>